<div class="flex min-h-screen flex-col">
  <div class="mt-5 px-6 py-4 md:px-16">
    <dhp-header
      [title]="'pages.authors.authors' | translate"
      [searchPlaceholder]="'pages.authors.filterByLastName' | translate"
      [showFilter]="true"
      [selectedMagazineIds]="selectedMagazineIds"
      (searchOutput)="onSearch($event)"
      (magazineSelected)="onMagazinesChange($event)"
    >
      <!-- Author Instructions - Mobile -->
      <div class="lg:hidden" headerActions>
        <button
          class="flex items-center gap-2 text-neutral-800 hover:text-neutral-600"
        >
          {{ 'pages.authors.authorInstructions' | translate }}
          <svg
            class="h-6 w-6"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.99997 18H18V20H5.99997V18ZM11 4V12.586L6.70697 8.293L5.29297 9.707L12 16.414L18.707 9.707L17.293 8.293L13 12.586V4H11Z"
              fill="currentColor"
            />
          </svg>
        </button>
      </div>

      <!-- Author Instructions - Desktop -->
      <div class="hidden lg:flex" headerEnd>
        <!--        <button class="btn btn-outline">-->
        <!--          {{ 'pages.authors.authorInstructions' | translate }}-->
        <!--          <svg class="h-6 w-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">-->
        <!--            <path-->
        <!--              d="M5.99997 18H18V20H5.99997V18ZM11 4V12.586L6.70697 8.293L5.29297 9.707L12 16.414L18.707 9.707L17.293 8.293L13 12.586V4H11Z"-->
        <!--              fill="black"-->
        <!--            />-->
        <!--          </svg>-->
        <!--        </button>-->
      </div>
    </dhp-header>
    <dhp-authors-list></dhp-authors-list>
  </div>
</div>
